export default "__VITE_ASSET__BqduiYTQ__"